// extracted by mini-css-extract-plugin
module.exports = {"root":"_2LRne","link":"_1bFte","arrowIcon":"_1Zg_h","heading":"_3lVmh"};